/**
 * Bridges legacy definition integrations (custom fetch/create method names) to ReferenceDataTablePage contract.
 */
export function attachReferenceTableContract(integration, { fetch, create, update, remove, bulkRemove }) {
    integration.fetchList = (...args) => integration[fetch](...args);
    integration.createRecord = (data) => integration[create](data);
    integration.updateRecord = (id, data) => integration[update](id, data);
    integration.removeRecord = (id) => integration[remove](id);
    if (bulkRemove) {
        integration.bulkRemoveRecords = (ids) => integration[bulkRemove](ids);
    }
    return integration;
}
